/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waitlist_HintInputs */



/**
* | output |
* | --- |
* | "Signed up after the event was full. Can't check in until you promote them." |
*
* @param {Waitlist_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const waitlist_hint = /** @type {((inputs?: Waitlist_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waitlist_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscrit alors que le tournoi était complet. Ne peut pas pointer tant que vous ne l'avez pas accepté.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se inscribió con el torneo lleno. No puede hacer check-in hasta que usted lo admita.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscreveu-se com o torneio lotado. Não pode fazer check-in até você admiti-lo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscritto a torneo già pieno. Non può fare il check-in finché non lo ammetti.")
	return /** @type {LocalizedString} */ ("Signed up after the event was full. Can't check in until you promote them.")
});